import React, { useState, useRef , useEffect} from "react";
import { Link, useNavigate,useLocation,  useSearchParams  } from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";

import axios from "axios";

import mainBg from "../assets/main_bg.png";
import mainBg_eng from "../assets/mng_main.png";
import mainBg_eng2 from "../assets/eng_main_page.png";
import mainBg_ru from "../assets/main_bg_ru.png";

import { AuthMe } from "../lib/MyHttp";
import { Update } from "../lib/User";


const Main = () => {
    const { t,i18n } = useTranslation();
    const navigate = useNavigate();

    const [data, setData] = useState();
    const [searchParams] = useSearchParams();

    const LIGHT_API = "http://127.0.0.1:18790";

    const turnOffLight = async () => {
        try {
            await axios.post(`${LIGHT_API}/light/off`, {}, { timeout: 800 });
        } catch (e) {
            console.warn("Local light OFF skipped");
        }
    };


    useEffect(() => {
        let token = searchParams.get("token");
        if (!!token) {
            localStorage.setItem("fb_token", token);
        } else {
            token = localStorage.getItem("fb_token");
        }

        if (!!token && data) {
            data.fb_token = token;
            Update(
                data,
                res => {
                    localStorage.setItem("fb_token", "");
                },
                res => {}
            );
        }
    }, [searchParams, data]);

    useEffect(() => {
         turnOffLight();
         
        AuthMe(
            res => {
                setData(res);
            },
            res => {
                setData();
            }
        );

        return () => {};
    }, []);


    const clickStart= () => {
        navigate('/agree');
    };

    const clickLogin= () => {
        navigate('/login');
    };

    var lng=i18n.language;


    return (
        <main className="main-container">
            <div className="main-bg">
                {lng == "ko" && <img src={mainBg} />}

                {lng == "mn" && <img src={mainBg_eng} />}

                {lng == "en" && <img src={mainBg_eng2} />}

                {lng == "ru" && <img src={mainBg_ru} />}
            </div>

            <div className="start-btn-area">
                {!data && (
                    <button className="Start" onClick={() => clickLogin()}>
                        {t("시작하기")}
                    </button>
                )}
                {data && (
                    <button className="Start" onClick={() => clickStart()}>
                        {t("시작하기")}
                    </button>
                )}
            </div>
        </main>
    );
};

export default Main;
